import React from 'react';
import { LiaTimesSolid } from 'react-icons/lia';
import { formatAmount, formatDateStrToDate } from '../utils';

function ModalHistoryDetails({ content }) {
  const { transactionHistoryDetails, handleOpenandCloseModal } = content;

  return (
    <article className='bg-p-wh shadow-lg px-8 py-8 gap-4 flex flex-col fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-128 rounded-md'>
      <>
        <div className='flex flex-col  pb-2 border-b-hf border-dashed'>
          {/* <img src={success} alt="success" className="w-20" /> */}
          <p className='text-gree-500 text-[18px] font-semibold'>
            Transaction{' '}
            {!!transactionHistoryDetails.payment ? 'Completed' : 'Cancelled'}
          </p>
        </div>
        <span
          className='absolute items-center  top-8 right-6 text-2xl text-s-bk cursor-pointer hover:text-p-bk'
          onClick={() => handleOpenandCloseModal('close')}
        >
          <LiaTimesSolid />
        </span>
        <div className='flex flex-row justify-between'>
          <span className='text-s-bk'> Date</span>{' '}
          <span>
            {formatDateStrToDate(transactionHistoryDetails?.created_at)}
          </span>
        </div>
        <div className='flex flex-row justify-between'>
          <span className='text-s-bk'>Payment Method</span>
          <span>{transactionHistoryDetails?.transaction_method?.name}</span>
        </div>
        <div className='flex flex-row justify-between'>
          <span className='text-s-bk'>Currency</span>
          <span>
            {' '}
            {transactionHistoryDetails?.base_currency.name} (
            {transactionHistoryDetails?.base_currency.symbol})
          </span>
        </div>

        <div className='flex flex-row justify-between'>
          <span className='text-s-bk'>Amount of CX</span>{' '}
          <span>
            {!!transactionHistoryDetails.payment
              ? formatAmount(transactionHistoryDetails?.payment?.cx_amount)
              : '0.00'}
          </span>
        </div>
        <div className='bg-b-mct border-dashed border-s-bk border-y-hf flex flex-col gap-2 py-2'>
          <div className='flex flex-row justify-between'>
            <span>Rate</span>
            <span>
              {!!transactionHistoryDetails.payment
                ? formatAmount(transactionHistoryDetails?.payment?.rate)
                : '0.00'}
            </span>
          </div>

          <div className='flex flex-row justify-between'>
            <span>Total Amount</span>{' '}
            <span className='font-semibold'>
              {!!transactionHistoryDetails.payment
                ? formatAmount(transactionHistoryDetails?.payment?.total)
                : '0.00'}
            </span>
          </div>
        </div>
      </>
      <div className='-rotate-45 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -z-10 whitespace-nowrap'>
        <p className='text-3xl font-medium opacity-20 text-b-mc '>
          Transaction{' '}
          {!!transactionHistoryDetails.payment ? 'Completed' : 'Cancelled'}
        </p>
      </div>
    </article>
  );
}

export default ModalHistoryDetails;
